module.exports = __webpack_public_path__ + "static/media/stair.585185c9.webp";